"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PronunciationLevel = exports.Level = exports.UserPreferencesDefaults = exports.isUserPreferences = exports.UserPreferencesSchema = exports.AllOneTimeModals = exports.AllHowDidYouHearOptions = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const typing_utils_1 = require("../typing_utils");
const language_codes_types_1 = require("./language_codes_types");
const weekdays_types_1 = require("./weekdays_types");
exports.AllHowDidYouHearOptions = [
    "SocialMedia",
    "WebSearch",
    "BlogOrNews",
    "OnlineAds",
    "AppStore",
    "FriendsOrFamily",
];
// Turn into array when there's another one-time modal to keep track of
exports.AllOneTimeModals = "offer_help_new_user";
const HowDidYouHearOptionSchema = zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(exports.AllHowDidYouHearOptions));
// Turn into union literal tuple when AllOneTimeModals is an array
const OneTimeModalSchema = zod_1.z.literal(exports.AllOneTimeModals);
exports.UserPreferencesSchema = zod_1.z.object({
    areWordOrderFlashcardsEnabled: zod_1.z.boolean(),
    currentUserLanguageCode: language_codes_types_1.LanguagePairCodeSchema.optional(),
    dismissedFlashTipIds: zod_1.z.string().array(),
    dismissedMinimalPairExplanationModal: zod_1.z.boolean(),
    dismissedReviewIncorrectModal: zod_1.z.boolean(),
    dismissedReviewRepetitionModal: zod_1.z.boolean(),
    everUsedUserLanguageCodes: zod_1.z.array(language_codes_types_1.LanguagePairCodeSchema),
    hasCompletedGuidedLearning: zod_1.z.boolean(),
    hasCompletedReviewOnboarding: zod_1.z.boolean(),
    hasDismissedGrammarArticleTile: zod_1.z.boolean(),
    hasDismissedWordOrderFlashcardsModal: zod_1.z.boolean(),
    hasEverSetStudyReminderTime: zod_1.z.boolean(),
    hasOfferedToHelp: zod_1.z.boolean().optional(),
    hasShownEnglishLanguageIntendedForCoachingModal: zod_1.z.boolean(),
    howDidYouHear: HowDidYouHearOptionSchema.optional(),
    isFrenchBootcampParticipant: zod_1.z.boolean(),
    isGuidedLearningEnabled: zod_1.z.boolean(),
    isJapaneseBootcampParticipant: zod_1.z.boolean(),
    isMxuBootcampParticipant: zod_1.z.boolean(),
    lastHomeNotificationDate: zod_1.z.string(),
    lastUsedAppVersion: zod_1.z.string().optional(),
    lastUsedCodePushVersion: zod_1.z.number().optional(),
    localPushNotificationsEnabled: zod_1.z.boolean(),
    localPushNotificationsTime: zod_1.z.string(),
    minimalPairOnboardingCompleted: zod_1.z.boolean(),
    minutesToStudyPerDay: zod_1.z.number().optional(),
    mxuBootcampLastViewed: zod_1.z.string(),
    newSentenceNotificationDecision: zod_1.z
        .union([zod_1.z.literal("yes"), zod_1.z.literal("no"), zod_1.z.literal("other")])
        .optional(),
    onboardingTutorialCompleted: zod_1.z.boolean(),
    onboardingTutorialSkipped: zod_1.z.boolean(),
    registeredForRetailAfterMondaySurveyNps: zod_1.z.boolean(),
    registeredForRetailAfterUpgradingNps: zod_1.z.boolean(),
    reviewsDuringPronunciationLessonsEnabled: zod_1.z.boolean(),
    seenOneTimeModals: OneTimeModalSchema.array(),
    showBoldWordsPopup: zod_1.z.boolean(),
    thankYouForJoiningScreenClosed: zod_1.z.boolean(),
    toolTipsCreateWordAdded: zod_1.z.boolean(),
    toolTipsCreateWordSwipe: zod_1.z.boolean(),
    toolTipsEnabled: zod_1.z.boolean(),
    userDisabledReviewControls: zod_1.z.boolean(),
    userGuidance: zod_1.z.boolean(),
    weekdaysToLearn: weekdays_types_1.WeekdaySchema.array(),
    welcomeVideoNotificationDismissed: zod_1.z.boolean(),
});
exports.isUserPreferences = type_validation_helpers_1.getVerboseTypeValidationFunction(exports.UserPreferencesSchema);
exports.UserPreferencesDefaults = {
    areWordOrderFlashcardsEnabled: false,
    dismissedFlashTipIds: [],
    dismissedMinimalPairExplanationModal: false,
    dismissedReviewIncorrectModal: false,
    dismissedReviewRepetitionModal: false,
    everUsedUserLanguageCodes: [],
    hasCompletedGuidedLearning: false,
    hasCompletedReviewOnboarding: false,
    hasDismissedGrammarArticleTile: false,
    hasDismissedWordOrderFlashcardsModal: false,
    hasEverSetStudyReminderTime: false,
    hasShownEnglishLanguageIntendedForCoachingModal: false,
    isFrenchBootcampParticipant: false,
    isGuidedLearningEnabled: false,
    isJapaneseBootcampParticipant: false,
    isMxuBootcampParticipant: false,
    lastHomeNotificationDate: "2000-01-01T00:00Z",
    localPushNotificationsEnabled: true,
    localPushNotificationsTime: "10:00",
    minimalPairOnboardingCompleted: false,
    mxuBootcampLastViewed: new Date(0).toISOString(),
    onboardingTutorialCompleted: false,
    onboardingTutorialSkipped: false,
    registeredForRetailAfterMondaySurveyNps: false,
    registeredForRetailAfterUpgradingNps: false,
    reviewsDuringPronunciationLessonsEnabled: true,
    seenOneTimeModals: [],
    showBoldWordsPopup: true,
    thankYouForJoiningScreenClosed: false,
    toolTipsCreateWordAdded: true,
    toolTipsCreateWordSwipe: true,
    toolTipsEnabled: true,
    userDisabledReviewControls: false,
    userGuidance: true,
    weekdaysToLearn: [],
    welcomeVideoNotificationDismissed: false,
};
var Level;
(function (Level) {
    Level[Level["Unknown"] = 0] = "Unknown";
    Level[Level["Beginner"] = 1] = "Beginner";
    Level[Level["Intermediate"] = 2] = "Intermediate";
    Level[Level["Advanced"] = 3] = "Advanced";
})(Level = exports.Level || (exports.Level = {}));
var PronunciationLevel;
(function (PronunciationLevel) {
    PronunciationLevel[PronunciationLevel["Beginner"] = 3] = "Beginner";
    PronunciationLevel[PronunciationLevel["Intermediate"] = 2] = "Intermediate";
    PronunciationLevel[PronunciationLevel["Advanced"] = 1] = "Advanced";
})(PronunciationLevel = exports.PronunciationLevel || (exports.PronunciationLevel = {}));
//# sourceMappingURL=user_preferences_types.js.map